<template>
  <div>
    <!-- <div class="newewsm_head">
    </div> -->
    <div class="newewsm_body">
      <div class="newewsm_white">
        <div class="featurenewheadtext">
          <img src="../assets/img/dengp.png" alt="" style="position:relative;top:-5px;left:-8px">
          <p
            style="
              font-size: 18px;
              color: #275479;
              font-weight: bold;
              line-height: 44px;
              text-align:center;
              display: inline-block;
              vertical-align: bottom;
              position:relative;
              left:-8px;
            "
          >
            解决方案-{{title_change}}
          </p>
        </div>
        <div class="newewsm_form">
          <a :href="download_url" class="newewsm_download" style="position:absolute;right:-70px;top:15px"><img src="../assets/img/pdf-png.png" alt="" style="position:relative;left:-5px;top:3px;">{{download_text}}</a>
          <div class="newewsm_item" v-if="$route.query.id=='fof'">
            <h3><span>{{index1[0]}}</span> <span>合规留痕</span></h3>
            <p class="pimg"><img src="../assets/feaimg/new03.png" alt="" ></p>
            <div>
              <h2><strong>● </strong>自定义指令流程审批策略</h2>
              <div class="p_style1">TMS可对不同的产品和策略创建不同工作流程。根据机构内部人员的角色和权限，将不同的工作流分配给相关人员，实现多级审批，确保交易指令的产生、审批、执行等环节符合相关的合规要求和监管标准。</div>
              <h2><strong>● </strong>回溯记录工具</h2>
              <div class="p_style1">系统提供了全面的交易数据和操作数据记录功能，包括存储终端的IP、MAC地址等相关信息。这些数据将被永久保存，并且提供了导出功能，便于自检或配合监管部门进行合规性检查。</div>
              <div class="p_style1">此外，系统还支持登录白名单控制，可以根据IP和MAC地址分别进行控制。通过配置白名单，在系统登录时只允许来自指定IP或MAC地址的用户接入系统，从而增强系统的安全性和访问控制能力。</div>
            </div>
          </div>
          <div class="newewsm_item">
            <h3><span>{{index1[1]}}</span> <span>交易管理</span></h3>
            <h2>（一）多通道组合管理交易分层管理体系</h2>
            <p class="pimg"><img src="../assets/feaimg/03.png" alt=""></p>
            <div class="flex1">
              <p><strong>● </strong>产品层：支持一个产品绑定多个资金账号；</p>
              <p><strong>● </strong>资金层：支持添加不同期货公司、不同交易后台的资金账号；</p>
              <p><strong>● </strong>交易执行层：每个投资账号独立结算，支持多种交易模式。</p>
              <p><strong>● </strong>策略分组：支持将多个相同策略的投资账号绑定为一个交易组，可统一管理，组合风控。</p>
            </div>
            <div class="flex2">
              <div v-for="(item,index) in item1" :key="index" class="flex2_ball">
                <div class="before"></div>
                <div class="after"></div>
                <div><span style="position: relative;top: 10px;white-space: nowrap;">{{item.title1}}</span></div>
                <div class="ball_text"><div>{{item.text1}}</div></div>
              </div>
            </div>
            <h2>（二）算法交易服务器</h2>
            <p class="pimg"><img src="../assets/feaimg/04.png" alt=""></p>
            <p class="p_style2"><strong>● </strong>支持标准化的C++接口，和Python接口，支持直接调用算法交易策略。</p>
            <p class="p_style2"><strong>● </strong>所有算法策略在服务器端运行，不受本地硬件、网络的影响。既能够保证交易稳定、快速的执行，又能通过拆单算法，提高交易效率，降低冲击成本。</p>
          </div>
          <div class="newewsm_item">
            <h3><span>{{index1[2]}}</span> <span>风险控制</span></h3>
            <p class="pimg"><img src="../assets/feaimg/05a.png" alt=""></p>
            <div class="flex3">
              <div><strong>● </strong>风控人员可按照投资账户、资金账户、产品、策略组等层级设立了不同层级的风险控制指标，实现事前、事中、事后全方位风险控制。</div>
              <div><strong>● </strong>系统通过风险计算引擎，在确保合规兼顾效率的前提下，提高资金使用率，降低各层级的交易风险，形成一套完整的风险控制体系。</div>
            </div>
            <div class="flex4">
              <div>
                <div class="text-item" style="margin-top:20px">
                  <h3>广泛支持扩展性交易规则</h3>
                  <p>风控人员无需手动配置规则，可通过风险计算引擎自动获取交易所的扩展性交易规则并进行实时更新，确保TMS系统与扩展性规则保持同步，防止机构误触合规风险指标，提高交易的合规性和稳定性，丰富机构盈利模式。</p>
                  <p>通常包含对关联账号进行配置、自动识别和防止自成交、频繁报撤、大额报撤、持仓限额、交易限额以及申报费等方面的规则。</p>
                </div>
              </div>
              <div style="margin:40px 30px 0 30px"><p class="pimg"><img src="../assets/feaimg/05b.png" alt="" style="width:200px"></p></div>
              <div>
                <div class="text-item">
                  <h3>投资账户自由组合风险公式</h3>
                  <p>风控员可通过净值监控、金额监控、市值监控、回撤率监控、保证金监控、亏损监控、隔夜监控等七大类实时风控指标，同时还支持自定义风控公式，可根据不同交易场景，灵活设定不同的风控标准，在确保投资安全的同时，提高资金使用率和策略收益。</p>
                </div>
                <div class="text-item" style="margin-top:50px">
                  <h3>策略组合风控</h3>
                  <p>风控人员可通过策略组合风控，将不同投资经理的交易策略，进行组合风险管理和监控，从而根据不同策略的特点和表现，有效管理和保护投资组合的稳定性。同时，也根据实际情况和投资顾问的需求，进行必要的调整和优化，以提高投资组合的稳定性和收益能力。</p>
                </div>
              </div>
            </div>
          </div>
          <div class="newewsm_item">
            <h3><span>{{index1[3]}}</span> <span>绩效考核场景</span></h3>
            <div class="p_style1">TMS可以直观地了解每个交易员的表现和贡献。数据表涵盖了交易员本月内的权益变化、平仓盈亏、手续费和净值变化等关键数据,为交易员业绩考核提供依据。</div>
            <div class="p_style1">此外，还可以根据分析需要切换季度、年度统计表，以全面了解交易员的长期绩效和交易稳定性。</div>
            <p class="pimg"><img src="../assets/feaimg/06a.png" alt="" style="margin-top:20px;"></p>
            <h2>特色功能：Execl函数插件</h2>
            <div class="p_style1">通过TMS的函数插件功能，可使用Office/WPS调用各种数据，包括资金详情、委托、成交、持仓列表、绩效考核表以及交易分析等。可自定义分析模板，实现多样化的数据分析。同时，支持一键更新数据，使盘后分析更加方便和快捷，提高团队的工作效率。</div>
            <p class="pimg" style="margin-top:20px"><img src="../assets/feaimg/06b.png" alt="" style="width:716px"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      title_change:'私募/团队的业务管理',
      download_text:'点击下载私募/团队业务管理一站式解决方案',
      download_url:'https://ftpc.wenhua.com.cn/files/guide/TMS/%E7%A7%81%E5%8B%9F%E5%9B%A2%E9%98%9F%E4%B8%9A%E5%8A%A1%E7%AE%A1%E7%90%86%E4%B8%80%E7%AB%99%E5%BC%8F%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88.pdf',
      src:'',
      ifimg:false,
      item1:[
        {
          title1:'一对一模式',
          text1:'一个资金账号对应一个投资账号，适合重点使用风控功能的使用场景。',
        },
        {
          title1:'一对多模式',
          text1:'一个资金账号对应多个投资账号，适合有多个投资经理/交易员同时使用一个资金账号下单的使用场景。',
        },
        {
          title1:'多对一模式',
          text1:'多个资金账号对应一个投资账号，适合一个投资经理同时管理多个资金账号交易的使用场景。',
        },
        {
          title1:'多对多模式',
          text1:'多个资金账号对应多个投资账号，适合中大型私募综合交易管理的使用场景。',
        },
      ],
      index1:['一','二','三','四','五','六']
    }
  },
  methods:{
    showimg(e){
      this.src=e
      this.ifimg=true
    },
  },
  watch:{
    '$route.query':{
      handler: function (newdata){
        if(newdata.id!='fof'){
          this.index1=['一','一','二','三','四','五','六']
          this.title_change="私募/团队的业务管理"
          this.download_text='点击下载私募/团队业务管理一站式解决方案'
          this.download_url='https://ftpc.wenhua.com.cn/files/guide/TMS/%E7%A7%81%E5%8B%9F%E5%9B%A2%E9%98%9F%E4%B8%9A%E5%8A%A1%E7%AE%A1%E7%90%86%E4%B8%80%E7%AB%99%E5%BC%8F%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88.pdf'
        }
        else{
          console.log(this.download_text)
          this.download_text='点击下载期货公司资管部门业务管理一站式解决方案'
          this.download_url='https://ftpc.wenhua.com.cn/files/guide/TMS/%E6%9C%9F%E8%B4%A7%E5%85%AC%E5%8F%B8%E8%B5%84%E7%AE%A1%E9%83%A8%E9%97%A8%E4%B8%9A%E5%8A%A1%E7%AE%A1%E7%90%86%E4%B8%80%E7%AB%99%E5%BC%8F%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88.pdf'
          console.log(this.index1)
          this.title_change="期货公司资管部门业务管理"
          this.index1=['一','二','三','四','五','六']
        }
      console.log(newdata)
      },
      immediate:true,
      deep:true,
    }
  },
  // created(){
  //   if(this.$route.query.id!='fof'){
  //       this.index1=['一','一','二','三','四','五','六']
  //     this.download_text='点击下载私募/团队业务管理一站式解决方案.pdf'
  //      this.download_url='https://ftpc.wenhua.com.cn/files/guide/TMS/%E7%A7%81%E5%8B%9F%E5%9B%A2%E9%98%9F%E4%B8%9A%E5%8A%A1%E7%AE%A1%E7%90%86%E4%B8%80%E7%AB%99%E5%BC%8F%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88.pdf'
  //   }
  //   else{
  //     this.download_text='点击下载期货公司资管部门业务管理一站式解决方案.pdf'
  //     this.download_url='https://ftpc.wenhua.com.cn/files/guide/TMS/%E6%9C%9F%E8%B4%A7%E5%85%AC%E5%8F%B8%E8%B5%84%E7%AE%A1%E9%83%A8%E9%97%A8%E4%B8%9A%E5%8A%A1%E7%AE%A1%E7%90%86%E4%B8%80%E7%AB%99%E5%BC%8F%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88.pdf'
  //     console.log(this.index1)
  //     this.index1=['一','二','三','四','五','六']
  //   }
  // }
}
</script>
<style scoped>
.newewsm_head {
  height: 275px;
  background: url(../assets/img/xz-banner.jpg) no-repeat center;
  /* border-bottom: 4px solid #f4b767; */
  position: relative;
}
.newewsm_body {
  /* padding-bottom: 98px; */
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=75) no-repeat center top,#e3effb;
  color: #656565;
  /* height: 734px; */
  /* overflow: hidden; */
  padding-top: 138px;
}
.featurenewheadtext {
  position: absolute;
  top: -50px;
}
.newewsm_white{
    width: 1060px;
    background: white;
    margin: 0 auto;
    height: 100%;
    padding-bottom: 50px;
    border-radius: 10px;
    box-shadow: 0 0 20px -5px #ccc;
    position: relative;
}
.newewsm_form{
  width: 870px;
  margin: 0 auto;
  padding-top: 40px;
  font-size: 14px;
  text-align: left;
  color: #434343;
  position: relative;
}
.newewsm_download{
  color: #4378b3;
  text-align: left;
  font-size: 14px;
}
.newewsm_download:visited{
  color: #4378b3;
}
.pimg {
  padding-top: 15px;
  padding-bottom: 15px;
  min-height: 50px;
  width: 100%;
  text-align: center;
}
/* .pimg img {
  width: 666px;
} */
.newewsm_item{
  margin-top: 40px;
}
.newewsm_item h3{
  margin-bottom: 20px;
  color: #083f92;
  font-size: 16px;
  font-weight: bold;
  height: 31px;
  line-height: 31px;
  display: flex;
  flex-direction: row;
  margin-left: -27px;
  background: #f0f7ff;
  border-radius: 0 10px 0 0;
}
.newewsm_item h3 span:first-child{
  display: inline-block;
  width: 44px;
  background: url(../assets/img/tub1.png)no-repeat left;
  padding-left: 13px;
  height: 100%;
  color: white;
}
.newewsm_item h3 span:last-child{
  display: inline-block;
  height: 100%;
  color: #2d68aa;
  padding-right: 12px;
}
.newewsm_item h2{
  margin: 20px 0 8px;
  font-weight: bold;
}
.flex1 {
  display: flex;
  flex-direction: column;
  flex-wrap:wrap;
}
.flex1 p{
  text-indent: -1em;
  margin: 1px 0;
  line-height: 21px;
}
.flex2{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 30px;
  margin-bottom: 40px;
}
.flex2_ball{
  width: 180px;
  height: 180px;
  overflow: hidden;
  border-radius: 100%;
  border: 1px solid #8fabd2;
  background: #f8fcff;
}
/* .flex2_ball .before {
    content: "";
    float: left;
    width: 50%; height: 100%;
    shape-outside: radial-gradient(farthest-side ellipse at right, transparent 100%, red);
}
.flex2_ball .after{
    content: "";
    float: right;
    width: 50%; height: 100%;
    shape-outside: radial-gradient(farthest-side ellipse at left, transparent 100%, red);
} */
.flex2_ball div:nth-of-type(3){
  background: #89b5e2;
  color: #fffefd;
  height: 40px;
  text-align: center;
}
.ball_text{
  background: #f8fcff;
  color: #6c7c96;
}
.ball_text div{
  margin: 5px 20px;
}
.flex3{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.flex3 div{
  width: 47%;
}
.flex4 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #f8f9fb;
  /* margin: 0 -20px; */
  padding: 25px 20px;
  margin-top: 50px;
}
.flex4 .text-item h3{
  font-weight: bold;
  color: #434343;
  margin-left: 0;
  background: none;
}
.flex4 .text-item p{
  text-indent: 2em;
  text-align: justify;
}
.p_style1{
  text-indent: 2em;
}
.p_style2{
  margin: 4px 0;
  line-height: 22px;
}
</style>